import React, { useState } from "react";
import { styled } from "@mui/material/styles";

import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";

import { BORDER_GREY, BUTTON_BORDER_RADIUS, WHITE } from "~src/data/constant";

import CustomDatesContainer from "./customDatesContainer";
import moment from "moment";

const ModifiedFormControl = styled(FormControl)(() => ({
  margin: "10px",
  padding: "0 8px",
  border: `1px solid ${BORDER_GREY}`,
  borderRadius: BUTTON_BORDER_RADIUS,
  backgroundColor: WHITE,
  minWidth: 120,
}));

export default function DateFilterContainer({
  provider,
  handleDateChange,
  displayDates,
  setDisplayDates,
}) {
  const [customPeriod, setCustomPeriod] = useState("");

  const [isFromDateOpen, setIsFromDateOpen] = useState(false);
  const [isToDateOpen, setIsToDateOpen] = useState(false);
  const [fromDate, setFromDate] = useState(provider["transaction-fromdate"][0]);
  const [toDate, setToDate] = useState(provider["transaction-todate"][0]);
  const [isDateFilterUsed, setDateFilterUsed] = useState(false);

  return (
    <div
      className="filter-container flex-wrap d-flex align-items-center "
      style={{ width: "35rem" }}
    >
      <div>
        <CustomDatesContainer
          setDateFilterUsed={setDateFilterUsed}
          isDateFilterUsed={isDateFilterUsed}
          setCustomPeriod={setCustomPeriod}
          handleDateChange={handleDateChange}
          displayDates={displayDates}
          setDisplayDates={setDisplayDates}
        />
      </div>

      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <div className="d-flex align-items-center">
          <ModifiedFormControl variant="standard">
            <DatePicker
              open={isFromDateOpen}
              openOnFocus
              onClose={() => {
                setIsFromDateOpen(false);
                setDateFilterUsed(true);
              }}
              onOpen={() => {
                setIsFromDateOpen(true);
              }}
              onAccept={(value) => {
                const requiredFormat = value.toISOString().slice(0, 10);
                setFromDate(requiredFormat);
                handleDateChange({
                  target: {
                    name: "transaction-fromdate",
                    value: requiredFormat,
                  },
                });
              }}
              views={["year", "month", "day"]}
              maxDate={new Date()}
              id="from-date"
              okLabel="Done"
              value={
                displayDates.startDate
                  ? moment(displayDates.startDate).format("YYYY-MM-DD")
                  : moment(
                      provider["transaction-fromdate"][0],
                      "DD-MM-YYYY"
                    ).format("YYYY-MM-DD")
              }
              allowSameDateSelection
              onChange={(value) => {
                if (value != "Invalid Date") {
                  const requiredFormat = value.toISOString().slice(0, 10);
                  setFromDate(requiredFormat);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  helperText={null}
                  variant="standard"
                  InputProps={{
                    ...params.InputProps,
                    disableUnderline: true,
                    style: {
                      width: "10rem",
                    },
                  }}
                />
              )}
            />
          </ModifiedFormControl>
          <span> to</span>
          <ModifiedFormControl variant="standard">
            <DatePicker
              open={isToDateOpen}
              openOnFocus
              onClose={() => {
                setIsToDateOpen(false);
                setDateFilterUsed(true);
              }}
              onOpen={() => {
                setIsToDateOpen(true);
              }}
              onAccept={(value) => {
                const requiredFormat = value.toISOString().slice(0, 10);
                setToDate(requiredFormat);
                handleDateChange({
                  target: { name: "transaction-todate", value: requiredFormat },
                });
              }}
              views={["year", "month", "day"]}
              maxDate={new Date()}
              id="to-date"
              okLabel="Done"
              autoOk={false}
              value={
                displayDates.endDate
                  ? moment(displayDates.endDate).format("YYYY-MM-DD")
                  : moment(
                      provider["transaction-todate"][0],
                      "DD-MM-YYYY"
                    ).format("YYYY-MM-DD")
              }
              allowSameDateSelection
              onChange={(value) => {
                if (value != "Invalid Date") {
                  const requiredFormat = value.toISOString().slice(0, 10);
                  setFromDate(requiredFormat);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  helperText={null}
                  variant="standard"
                  InputProps={{
                    ...params.InputProps,
                    disableUnderline: true,
                    style: {
                      width: "10rem",
                    },
                  }}
                />
              )}
            />
          </ModifiedFormControl>
        </div>
      </LocalizationProvider>
    </div>
  );
}








//by default 12 month filter
// import React, { useState, useEffect } from "react";
// import { styled } from "@mui/material/styles";

// import FormControl from "@mui/material/FormControl";
// import TextField from "@mui/material/TextField";
// import AdapterDateFns from "@mui/lab/AdapterDateFns";
// import LocalizationProvider from "@mui/lab/LocalizationProvider";
// import DatePicker from "@mui/lab/DatePicker";

// import { BORDER_GREY, BUTTON_BORDER_RADIUS, WHITE } from "~src/data/constant";

// import CustomDatesContainer from "./customDatesContainer";
// import moment from "moment";

// const ModifiedFormControl = styled(FormControl)(() => ({
//   margin: "10px",
//   padding: "0 8px",
//   border: `1px solid ${BORDER_GREY}`,
//   borderRadius: BUTTON_BORDER_RADIUS,
//   backgroundColor: WHITE,
//   minWidth: 120,
// }));

// export default function DateFilterContainer({
//   provider,
//   handleDateChange,
//   displayDates,
//   setDisplayDates,
// }) {
//   const [customPeriod, setCustomPeriod] = useState("last-12-months");

//   const [isFromDateOpen, setIsFromDateOpen] = useState(false);
//   const [isToDateOpen, setIsToDateOpen] = useState(false);
//   const [fromDate, setFromDate] = useState(provider["transaction-fromdate"][0]);
//   const [toDate, setToDate] = useState(provider["transaction-todate"][0]);
//   const [isDateFilterUsed, setDateFilterUsed] = useState(false);

//   // Initialize with Last 12 Months dates
//   useEffect(() => {
//     const currentDate = new Date();
//     const calculatedFromDate = moment(currentDate)
//       .subtract(12, "months")
//       .startOf("month")
//       .format("YYYY-MM-DD");
//     const calculatedToDate = moment(currentDate)
//       .subtract(1, "months")
//       .endOf("month")
//       .format("YYYY-MM-DD");

//     // Set the initial display dates
//     setDisplayDates({
//       startDate: calculatedFromDate,
//       endDate: calculatedToDate
//     });

//     // Update the provider values via handleDateChange
//     handleDateChange({
//       target: {
//         name: "time-period",
//         fromDate: calculatedFromDate,
//         toDate: calculatedToDate,
//       },
//     });
//   }, []);

//   return (
//     <div
//       className="filter-container flex-wrap d-flex align-items-center "
//       style={{ width: "35rem" }}
//     >
//       <div>
//         <CustomDatesContainer
//           setDateFilterUsed={setDateFilterUsed}
//           isDateFilterUsed={isDateFilterUsed}
//           setCustomPeriod={setCustomPeriod}
//           handleDateChange={handleDateChange}
//           displayDates={displayDates}
//           setDisplayDates={setDisplayDates}
//         />
//       </div>

//       <LocalizationProvider dateAdapter={AdapterDateFns}>
//         <div className="d-flex align-items-center">
//           <ModifiedFormControl variant="standard">
//             <DatePicker
//               open={isFromDateOpen}
//               openOnFocus
//               onClose={() => {
//                 setIsFromDateOpen(false);
//                 setDateFilterUsed(true);
//               }}
//               onOpen={() => {
//                 setIsFromDateOpen(true);
//               }}
//               onAccept={(value) => {
//                 const requiredFormat = value.toISOString().slice(0, 10);
//                 setFromDate(requiredFormat);
//                 handleDateChange({
//                   target: {
//                     name: "transaction-fromdate",
//                     value: requiredFormat,
//                   },
//                 });
//               }}
//               views={["year", "month", "day"]}
//               maxDate={new Date()}
//               id="from-date"
//               okLabel="Done"
//               value={
//                 displayDates.startDate
//                   ? moment(displayDates.startDate).format("YYYY-MM-DD")
//                   : moment(
//                       provider["transaction-fromdate"][0],
//                       "DD-MM-YYYY"
//                     ).format("YYYY-MM-DD")
//               }
//               allowSameDateSelection
//               onChange={(value) => {
//                 if (value != "Invalid Date") {
//                   const requiredFormat = value.toISOString().slice(0, 10);
//                   setFromDate(requiredFormat);
//                 }
//               }}
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   helperText={null}
//                   variant="standard"
//                   InputProps={{
//                     ...params.InputProps,
//                     disableUnderline: true,
//                     style: {
//                       width: "10rem",
//                     },
//                   }}
//                 />
//               )}
//             />
//           </ModifiedFormControl>
//           <span> to</span>
//           <ModifiedFormControl variant="standard">
//             <DatePicker
//               open={isToDateOpen}
//               openOnFocus
//               onClose={() => {
//                 setIsToDateOpen(false);
//                 setDateFilterUsed(true);
//               }}
//               onOpen={() => {
//                 setIsToDateOpen(true);
//               }}
//               onAccept={(value) => {
//                 const requiredFormat = value.toISOString().slice(0, 10);
//                 setToDate(requiredFormat);
//                 handleDateChange({
//                   target: { name: "transaction-todate", value: requiredFormat },
//                 });
//               }}
//               views={["year", "month", "day"]}
//               maxDate={new Date()}
//               id="to-date"
//               okLabel="Done"
//               autoOk={false}
//               value={
//                 displayDates.endDate
//                   ? moment(displayDates.endDate).format("YYYY-MM-DD")
//                   : moment(
//                       provider["transaction-todate"][0],
//                       "DD-MM-YYYY"
//                     ).format("YYYY-MM-DD")
//               }
//               allowSameDateSelection
//               onChange={(value) => {
//                 if (value != "Invalid Date") {
//                   const requiredFormat = value.toISOString().slice(0, 10);
//                   setToDate(requiredFormat);  // Fixed: this was incorrectly setting fromDate
//                 }
//               }}
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   helperText={null}
//                   variant="standard"
//                   InputProps={{
//                     ...params.InputProps,
//                     disableUnderline: true,
//                     style: {
//                       width: "10rem",
//                     },
//                   }}
//                 />
//               )}
//             />
//           </ModifiedFormControl>
//         </div>
//       </LocalizationProvider>
//     </div>
//   );
// }